import React, { useEffect } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import AppProviders from "./providers";
import AppRoutes from "./routes";
import RouteChangeTracker from "./RouteChangeTracker";
import FloatingButton from "../features/public/layout/FloatingButton";
import CookieConsent from "../features/public/layout/CookieConsent";
import { initFacebookPixel, disableFacebookPixel } from "../shared/utils/FacebookPixel";

function App() {
  const FB_PIXEL_ID = "618876082077967";

  const handleCookieAccept = () => {
    initFacebookPixel(FB_PIXEL_ID);
  };

  const handleCookieDecline = () => {
    disableFacebookPixel();
  };

  useEffect(() => {
    const consent = localStorage.getItem("cookieConsent");
    if (consent === "accepted") {
      initFacebookPixel(FB_PIXEL_ID);
    }
  }, []);

  return (
    <Router>
      <AppProviders>
        <div className="App">
          <RouteChangeTracker />
          <AppRoutes />

          <Routes>
            <Route path="/" element={<FloatingButton />} />
            <Route path="/piercing" element={<FloatingButton />} />
            <Route path="/laser" element={<FloatingButton />} />
          </Routes>

          <CookieConsent
            onAccept={handleCookieAccept}
            onDecline={handleCookieDecline}
          />
        </div>
      </AppProviders>
    </Router>
  );
}

export default App;
